<template>
	<div>
		<vs-row>
			<vx-card title="Dashboards">
				<template slot="actions">
					<vx-tooltip class="flex" text="Help">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>

				<div class="vx-col pt-2 pb-2">
					<div class="flex justify-between items-center">
						<div class="text-xs" v-if="dashboardList.length > 0">
							{{ dashboardList.length }} dashboard(s) gevonden
						</div>
						<vs-button color="primary" @click="openCreatePopup">
							<font-awesome-icon icon="plus"></font-awesome-icon>
							Nieuw Dashboard
						</vs-button>
					</div>
				</div>

				<vs-table :data="dashboardList" noDataText="Geen dashboards gevonden...">
					<vs-tr>
						<vs-th>Naam</vs-th>
						<vs-th colspan="2">Acties</vs-th>
					</vs-tr>

					<vs-tr :key="dashboard.id" v-for="dashboard in dashboardList">
						<td>
							{{ dashboard.name }}
						</td>
						<td>
							<div v-if="!dashboard.selected" @click="selectDashboard(dashboard.id)" class="cursor-pointer">
								<vs-chip color="light" class="text-black">
									Selecteer
								</vs-chip>
							</div>
							<div v-else>
								<vs-chip color="success">
									<font-awesome-icon icon="check" class="mr-1"></font-awesome-icon>
									Geselecteerd
								</vs-chip>
							</div>
							<td>
								<font-awesome-icon icon="edit" size="sm" @click="openEditPopup(dashboard)" style="cursor: pointer;"/>
							</td>
					</vs-tr>
				</vs-table>
			</vx-card>
		</vs-row>

		<!-- Create Dashboard Popup -->
		<vs-popup title="Nieuw Dashboard" :active.sync="createPopup">
			<form data-vv-scope="createForm" @submit.prevent>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Dashboard Naam *</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
							v-validate="'required'"
							name="name"
							class="w-full"
							placeholder="Voer dashboard naam in"
							v-model="dashboardData.name"
						/>
						<span class="text-danger text-sm" v-show="errors.has('createForm.name')">
							{{ errors.first('createForm.name') }}
						</span>
					</div>
				</div>

				<vs-divider></vs-divider>

				<div class="vx-row">
					<div class="vx-col w-full text-right">
						<vs-button class="mr-2" color="danger" type="flat" @click="closeCreatePopup">
							Annuleer
						</vs-button>
						<vs-button @click="createDashboard">Opslaan</vs-button>
					</div>
				</div>
			</form>
		</vs-popup>

		<!-- Edit Dashboard Popup -->
		<vs-popup title="Dashboard bewerken" :active.sync="editPopup">
			<form data-vv-scope="editForm" @submit.prevent>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Dashboard Naam *</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
							v-validate="'required'"
							name="name"
							class="w-full"
							placeholder="Voer dashboard naam in"
							v-model="editDashboardData.name"
						/>
						<span class="text-danger text-sm" v-show="errors.has('editForm.name')">
							{{ errors.first('editForm.name') }}
						</span>
					</div>
				</div>

				<vs-divider></vs-divider>

				<div class="vx-row">
					<div class="vx-col w-full text-right">
						<vs-button class="mr-2" color="danger" type="flat" @click="closeEditPopup">
							Annuleer
						</vs-button>
						<vs-button @click="saveDashboard">Opslaan</vs-button>
					</div>
				</div>
			</form>
		</vs-popup>
	</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);

const dict = {
	custom: {
		name: {
			required: 'Voer alstublieft een dashboard naam in'
		}
	}
};
Validator.localize('en', dict);

export default {
	name: 'DashboardManagement',
	computed: {
		...mapGetters({
			dashboardList: 'dashboard/dashboardList'
		})
	},
	data() {
		return {
			createPopup: false,
			editPopup: false,
			dashboardData: {
				name: ''
			},
			editDashboardData: {
				id: null,
				name: ''
			}
		};
	},
	mounted() {
		this.loadDashboards();
	},
	methods: {
		...mapActions({
			initDashboard: 'dashboard/init',
			selectDashboard: 'dashboard/changeSelectedDashboard',
			createNewDashboard: 'dashboard/createDashboard'
		}),
		loadDashboards() {
			this.$vs.loading();
			this.initDashboard()
				.then(() => {
					this.$vs.loading.close();
				})
				.catch(error => {
					console.error('Error loading dashboards:', error);
					this.$vs.loading.close();
					this.$vs.notify({
						title: 'Error',
						text: 'Er is iets fout gegaan bij het laden van dashboards',
						color: 'danger'
					});
				});
		},
		openCreatePopup() {
			this.dashboardData.name = '';
			this.$validator.reset();
			this.createPopup = true;
		},
		closeCreatePopup() {
			this.createPopup = false;
			this.dashboardData.name = '';
			this.$validator.reset();
		},
		createDashboard() {
			this.$validator.validateAll('createForm').then(result => {
				if (result) {
					this.$vs.loading();
					this.createNewDashboard(this.dashboardData.name)
						.then(() => {
							this.$vs.loading.close();
							this.$vs.notify({
								title: 'Succes!',
								text: 'Dashboard is succesvol aangemaakt',
								color: 'success'
							});
							this.closeCreatePopup();
						})
						.catch(error => {
							console.error('Error creating dashboard:', error);
							this.$vs.loading.close();
							this.$vs.notify({
								title: 'Error',
								text: 'Dashboard kon niet worden aangemaakt',
								color: 'danger'
							});
						});
				}
			});
		},
		openEditPopup(dashboard) {
			this.editDashboardData.id = dashboard.id;
			this.editDashboardData.name = dashboard.name;
			this.$validator.reset();
			this.editPopup = true;
		},
		closeEditPopup() {
			this.editPopup = false;
			this.editDashboardData.id = null;
			this.editDashboardData.name = '';
			this.$validator.reset();
		},
		saveDashboard() {
			this.$validator.validateAll('editForm').then(result => {
				if (result) {
					this.$vs.loading();
					this.$store.dispatch('dashboard/updateDashboard', {
						dashboard_id: this.editDashboardData.id,
						name: this.editDashboardData.name
					})
						.then(() => {
							this.$vs.loading.close();
							this.$vs.notify({
								title: 'Succes!',
								text: 'Dashboard is succesvol bijgewerkt',
								color: 'success'
							});
							this.loadDashboards();
							this.closeEditPopup();
						})
						.catch(error => {
							console.error('Error updating dashboard:', error);
							this.$vs.loading.close();
							this.$vs.notify({
								title: 'Error',
								text: 'Dashboard kon niet worden bijgewerkt',
								color: 'danger'
							});
						});
				}
			});
		},
		wiki() {
			if (this.$store.state.wiki && this.$store.state.wiki.wiki && this.$store.state.wiki.wiki.dashboard) {
				window.open(this.$store.state.wiki.wiki.dashboard);
			}
		}
	}
};
</script>
